import CandidateTypeLabels from '@/shared/constants/candidate/CandidateTypeLabels'

/**
 * Returns the Ready2Book display label for a Ready2Resource educator type
 * title. Unmapped or empty titles fall back to the trimmed input.
 *
 * @param {string} rrType - The educator type title from `candidate.types[].title`
 * @returns {string}
 */
export function mapEducatorType(rrType) {
  const key = (rrType ?? '').trim()
  return CandidateTypeLabels[key] ?? key
}

/**
 * ID of 'EC Working Towards' grade used to identify an in progress qualification.
 * If more grade id's are needed this should be moved to a shared constants file.
 * @type {number}
 */
const ECWorkingTowardsGrade = 1003

/**
 * Checks if a qualification is marked as 'EC Working Towards'.
 *
 * @param {Object} qualification - The qualification object from `candidate.qualifications[]`
 * @returns {boolean}
 */
export function isWorkingTowardsQual(qualification) {
  if (!qualification?.grades?.length) return false

  return qualification.grades.some(({ id }) => id === ECWorkingTowardsGrade)
}
